import * as settlementsService from '@/services/settlements-api.service';
import { camelizeKeys } from 'humps';
import { 
  SETTLEMENTS_ERROR,
  SETTLEMENTS_SUCCESS,
  SETTLEMENTS_LOADING,
  SETTLEMENT_CREATION_SET_SPONSOR_SLUG,
  SETTLEMENT_CREATION_SET_DATE_FROM,
  SETTLEMENT_CREATION_SET_DATE_TO,
  SELECT_SETTLEMENT_FOR_DETAIL,
  SET_SETTLEMENT_DETAIL,
  CLEAN_SETTLEMENT_DETAIL,
  SETTLEMENT_CREATION_BACK_STEP,
  SETTLEMENT_CREATION_NEXT_STEP,
  SET_PENDING_AUTHORIZATIONS,
  SET_SETTLEMENT_ID,
  CLEAR_SETTLEMENT_CREATION,
  SET_CLAIMS,
  CLEAR_CLAIMS,
  SET_EXCLUDED_CLAIMS,
  CLEAR_EXCLUDED_CLAIMS,
  COMPLETE_ADD_AUTHORIZATIONS_STEP,
  SET_SETTLEMENT_CREATION_RESULT,
  RESET_SETTLEMENT_CREATION_STATE,
  SET_UPLOAD_SETTLEMENT_FILES_STATUS,
  SET_SETTLEMENT_SUMMARY,
  SETTLEMENT_CREATION_SET_COVERAGES,
  SETTLEMENT_DOCUMENTS,
  MANUAL_AUTHORIZATION_TOGGLE,
  MANUAL_AUTHORIZATION_SET_QUANTITY,
  MANUAL_AUTHORIZATION_SET_AMOUNT
}from './types'

const getSettlements = async({ commit }, filters) => {
  commit(SETTLEMENTS_LOADING, true)
  try{
    const response = await settlementsService.getSettlements(filters);
    commit(SETTLEMENTS_SUCCESS, camelizeKeys(response.data))
    commit(SETTLEMENTS_LOADING, false)
  }catch(error){
    commit(SETTLEMENTS_ERROR, error)
    commit(SETTLEMENTS_LOADING, false)
  }
}

const setSponsorSlug = ({commit}, sponsorSlug) => {
  commit(SETTLEMENT_CREATION_SET_SPONSOR_SLUG, sponsorSlug)
}

const setDateFrom = ({commit}, date) => {
  commit(SETTLEMENT_CREATION_SET_DATE_FROM, date)
}

const setDateTo = ({commit}, date) => {
  commit(SETTLEMENT_CREATION_SET_DATE_TO, date)
}

const selectSettlement = async ({ commit, rootGetters }, settlementId) => {
  commit(SETTLEMENTS_LOADING, true)
  try{
    const providerSlug = rootGetters.tokenExtensions.providerSlug
    const response = await settlementsService.getSettlementDetail(settlementId, providerSlug)
    commit(SELECT_SETTLEMENT_FOR_DETAIL, camelizeKeys(response.data))
    commit(SETTLEMENTS_LOADING, false)
  }catch(error){
    commit(SETTLEMENTS_ERROR, error)
    commit(SETTLEMENTS_LOADING, false)
  }
}

const getDetail = async({ commit }, filters) => {
  commit(SETTLEMENTS_LOADING, true)
  try{
    const response = await settlementsService.getSettlementClaims(filters);
    commit(SET_SETTLEMENT_DETAIL, camelizeKeys(response.data))
    commit(SETTLEMENTS_LOADING, false)
  }catch(error){
    commit(SETTLEMENTS_ERROR, error)
    commit(SETTLEMENTS_LOADING, false)
  }
}

const cleanSettlementDetail = ({ commit }) => {
  commit(CLEAN_SETTLEMENT_DETAIL)
}

const backStep = ({commit})=> {
  commit(SETTLEMENT_CREATION_BACK_STEP)
}

const nextStep = ({commit})=> {
  commit(SETTLEMENT_CREATION_NEXT_STEP)
}

const setPendingAuthorizations = async ({ commit, state }, filters) => {
  commit(SETTLEMENTS_LOADING, true);
  try{
    filters["transactionTypes"] = state.createSettlement.coverages
    const response = await settlementsService.getPendingAuthorizations(filters);
    commit(SET_PENDING_AUTHORIZATIONS, camelizeKeys(response.data));
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }  
}

const setSettlementId = async ({ commit }, sponsorSlug) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, "")
  try{
    const response = await settlementsService.setSettlementId(sponsorSlug);
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SET_SETTLEMENT_ID, camelizeKeys(response.data));
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const clearSettlement = ({ commit }) => {
  commit(CLEAR_SETTLEMENT_CREATION)
}

const setClaims = async ({commit, state}) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, "")
  let filters = {
    settlementId: state.createSettlement.settlementId.id,
    claimIds: state.createSettlement.includedClaims.map(item => item.id),
    dateFrom: state.createSettlement.dates.from,
    dateTo: state.createSettlement.dates.to,
    excludedClaimIds: state.createSettlement.excludedClaims.map(item => item.id)
  }

  let body = {}
  if(filters.claimIds.length > 0){
    body = {
      settlementId: filters.settlementId,
      params: {
        claimIds: filters.claimIds
      }
    }
  }
  else{
    body = {
      settlementId: filters.settlementId,
      params: {
          searchCriteria: {
          dateFrom: filters.dateFrom,
          dateTo: filters.dateTo,
          excludedClaimIds: filters.excludedClaimIds
        }
      }
    }
  }

  try{
    await settlementsService.setClaims(body);
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const deleteClaims = async ({commit, state}) => {
  commit(SETTLEMENTS_LOADING, true);
  const claimIds = state.createSettlement.includedClaims.map(item => item.id)
  const excludedClaimIds = state.createSettlement.excludedClaims.map(item => item.id)
  const settlementId = state.createSettlement.settlementId.id

  try{
    if(excludedClaimIds.length > 0){
      await settlementsService.deleteClaims(settlementId, excludedClaimIds)
    }
    if(claimIds.length > 0){
      await settlementsService.deleteClaims(settlementId, claimIds)
    }
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const setIncludedClaim = ({commit}, payload) => {
  commit(SET_CLAIMS, payload)
}

const setExcludedClaim = ({commit}, payload) => {
  commit(SET_EXCLUDED_CLAIMS, payload)
}

const clearIncludedClaims = ({commit}) => {
  commit(CLEAR_CLAIMS)
}

const clearExcludedClaims = ({commit}) => {
  commit(CLEAR_EXCLUDED_CLAIMS)
}

const setAddAuthorizationsComplete = ({ commit }, complete) => {
  commit(COMPLETE_ADD_AUTHORIZATIONS_STEP, complete)
}

const sendSettlementFiles = async ({ commit, state }, payload) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, null)
  try{
    const settlementId = state.createSettlement.settlementId.id
    if(payload.length > 0){
      for(const file of payload){
        await settlementsService.sendSettlementFiles(settlementId, file)
      }
    }
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const completeSettlement = async ({ commit, state }, payload) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, null)
  try{
    const settlementId = state.createSettlement.settlementId.id
    await settlementsService.completeSettlement(settlementId, payload);
    commit(RESET_SETTLEMENT_CREATION_STATE) 
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const setSettlementCreationStatus = ({ commit }, payload) => {
  commit(SET_SETTLEMENT_CREATION_RESULT, payload)
}

const setUploadSettlementFilesStatus = ({commit}, payload) => {
  commit(SET_UPLOAD_SETTLEMENT_FILES_STATUS, payload)
}

const settlementSummary = async ({commit, state}) => {
  commit(SETTLEMENTS_LOADING, true);
  commit(SET_SETTLEMENT_CREATION_RESULT, null)
  try{
    const settlementId = state.createSettlement.settlementId.id
    const response = await settlementsService.settlementSummary(settlementId);
    commit(SET_SETTLEMENT_SUMMARY, camelizeKeys(response.data))
    commit(SET_SETTLEMENT_CREATION_RESULT, "SUCCESS")
    commit(SETTLEMENTS_LOADING, false);
  }catch(error){
    commit(SET_SETTLEMENT_CREATION_RESULT, "ERROR")
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const setSettlementCoverageAuthorizations = ({commit}, payload) => {
  commit(SETTLEMENT_CREATION_SET_COVERAGES, payload)
}

const existsSettlement = async ({ commit }, payload) => {
  commit(SETTLEMENTS_LOADING, true);
  try {
    const response = await settlementsService.existsSettlementByClaimAndSponsor(payload.claimId, payload.sponsorSlug);
    commit(SETTLEMENTS_LOADING, false);
    return response.data;
  } catch(error) {
    error.exists_settlement = false;
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
    return error;
  }
}

const settlementDocuments = async ({ commit }, payload) => {
  commit(SETTLEMENTS_LOADING, true);
  try {
    const documentsSettlement =  await settlementsService.getSettlementDocuments(payload);

    const newDocumentsSettlement = documentsSettlement.data.map(item => {
      const { id, ...object } = item;
      return { ...object, settlementFileId: id }
    })

    commit(SETTLEMENTS_LOADING, false);
    commit(SETTLEMENT_DOCUMENTS, camelizeKeys(newDocumentsSettlement));
  } catch(error) {
    commit(SETTLEMENTS_ERROR, error);
    commit(SETTLEMENTS_LOADING, false);
  }
}

const setManualAuthorizationDetails = ({commit}, payload) => { 
  const { type, value } = payload;

  switch(type) {
    case "TOGGLE": {
      commit(MANUAL_AUTHORIZATION_TOGGLE, value);

      break;
    }
    case "MANUAL_QUANTITY": {
      commit(MANUAL_AUTHORIZATION_SET_QUANTITY, value);

      break;
    }
    case "MANUAL_AMOUNT": {
      commit(MANUAL_AUTHORIZATION_SET_AMOUNT, value);

      break;
    }
  }
}

const clearManualAuthorizationsDetails = ({commit}) => {
  commit(MANUAL_AUTHORIZATION_TOGGLE, false)
  commit(MANUAL_AUTHORIZATION_SET_QUANTITY, '')
  commit(MANUAL_AUTHORIZATION_SET_AMOUNT, '');
}

export default { 
  settlementDocuments,
  getSettlements,
  existsSettlement,
  setSponsorSlug,
  setDateFrom,
  setDateTo,
  selectSettlement,
  getDetail,
  cleanSettlementDetail,
  backStep,
  nextStep,
  setPendingAuthorizations,
  setSettlementId,
  clearSettlement,
  setClaims,
  setIncludedClaim,
  clearIncludedClaims,
  setExcludedClaim,
  clearExcludedClaims,
  setAddAuthorizationsComplete,
  completeSettlement,
  setSettlementCreationStatus,
  sendSettlementFiles,
  setUploadSettlementFilesStatus,
  settlementSummary,
  setSettlementCoverageAuthorizations,
  deleteClaims,
  setManualAuthorizationDetails,
  clearManualAuthorizationsDetails
}